import React, { useState, useEffect } from "react";
import Leftpanel from "../layout/Leftpanel";
import Header from "../layout/Header";
import news from "../../images/news.jpg";
import { Link } from "react-router-dom";
import ReactPaginate from "react-paginate";
import instance from "../../../WebApi/WebApi";
import { debounce } from "lodash";

const News = () => {
  const [currentPage, setCurrentPage] = useState(0);
  const [allNews, setAllNews] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const PER_PAGE = 6;

  function handlePageClick({ selected: selectedPage }) {
    setCurrentPage(selectedPage);
  }

  const offset = currentPage * PER_PAGE;
  const pageCount = Math.ceil(totalCount / PER_PAGE);

  const debouncedSearch = debounce(() => {
    getAllNews();
  }, 500); // 500ms delay

  useEffect(() => {
    debouncedSearch(searchTerm);
    return () => {
      debouncedSearch.cancel();
    };
  }, [searchTerm]);

  useEffect(() => {
    getAllNews();
  }, []);

  const getAllNews = async () => {
    const data = {
      limit: PER_PAGE,
      offset: offset,
      searchKeyword: searchTerm,
    };
    const response = await instance.post(`customer/common/news-list`, data);
    console.log("response---->", response);
    setAllNews(response?.data?.data?.newsList);
    setTotalCount(response?.data?.data?.totalCount);
  };
  return (
    <div
      className={
        localStorage.getItem("gs3_AuthToken")
          ? "container-fluid"
          : "container-fluid aboutMain"
      }
    >
      <div className="dbMain">
        <Leftpanel />
        <div className="dbRight">
          <Header link="#" breadcm="" title="News" description="" />
          <div className="commonBase">
            {localStorage.getItem("gs3_AuthToken") ? (
              ""
            ) : (
              <h2 className="text-center pb-4">News</h2>
            )}
            <div>
              <input
                type="text"
                className="form-control"
                placeholder="Search..."
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <div className="row">
                {allNews?.length !== 0 &&
                  allNews?.map((d, i) => {
                    // Strip HTML to get plain text
                    const plainText = d.content.replace(/<[^>]+>/g, ""); // Removes all HTML tags
                    const words = plainText.split(" ");
                    const shortContent = words.slice(0, 50).join(" "); // Get first 120 words

                    return (
                      <div className="col-md-4 newscontainer" key={i}>
                        <img
                          src={d?.image}
                          alt="news"
                          style={{ maxWidth: "100%", height: "295px" }}
                        />
                        <h5>{d?.title}</h5>
                        <p>
                          <Link to={`/newsdetails?slugUrl=${d?.slugUrl}`}>
                            {shortContent}

                            {words.length > 50 && (
                              <>
                                ...{" "}
                                <span
                                  style={{ color: "green", cursor: "pointer" }}
                                >
                                  read more
                                </span>
                              </>
                            )}
                          </Link>
                        </p>
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>
          <ReactPaginate
            previousLabel={"previous"}
            nextLabel={"next"}
            pageCount={pageCount}
            onPageChange={handlePageClick}
            containerClassName={"pagination"}
            previousLinkClassName={"pagination__link"}
            nextLinkClassName={"pagination__link"}
            disabledClassName={"pagination__link--disabled"}
            activeClassName={"pagination__link--active"}
          />
        </div>
      </div>
    </div>
  );
};

export default News;
